import React from "react";
import Box from "@mui/material/Box";

import { replaceCollection } from "../../../components/TablePro/utils";
import ActionModal from "../../../components/modals/action-modal";
import useMutation from "../../../hooks/useMutation";
import { ASSETS_BULK_UPDATE_MUTATION } from "../../../constants/graphql";
import { useAssetsCollectionSafe } from "../../../contexts/assetsCollection";
import { useBanner } from "../../../contexts/banner";
import MultipleDestinationRoomNumberForm from "../../../components/TablePro/fields/assets/MultipleDestinationRoomNumberForm";

const noop = () => {};

export default function MultipleDestinationRoomNumberOrdersModal({ open, toggleModal, entity }) {
  const assetsCollection = useAssetsCollectionSafe();
  const setCollection = assetsCollection?.setCollection || noop;
  const setLoadingMutation = assetsCollection?.setLoadingMutation || noop;
  const [bulkUpdateAssets, { loading }] = useMutation(ASSETS_BULK_UPDATE_MUTATION);
  const { displayBanner } = useBanner();

  const handleSave = values => {
    setLoadingMutation(true);
    displayBanner({ message: "Processing...", type: "bulk-update-assets" });
    replaceCollection(setCollection, { [entity.id]: values });
    return bulkUpdateAssets({
      variables: { input: { id: entity.id, ...values } },
      onSuccess: () => {
        setLoadingMutation(false);
        toggleModal();
      },
    });
  };

  return open ? (
    <ActionModal
      open
      title="Destination Room Number"
      maxWidth={540}
      onClose={toggleModal}
      disableTransition
    >
      <Box mt={1} />
      <MultipleDestinationRoomNumberForm
        loading={loading}
        destinationRoomNumbers={entity.destinationRoomNumbers || []}
        toggleModal={toggleModal}
        onSubmit={handleSave}
      />
    </ActionModal>
  ) : null;
}
